const defaultString = '<table'
const desiredString = '<table style="display: inline-table; width: 100%;"'

export default (string = '') => {
  return string.replace(defaultString, desiredString)
}
